import { ProgramCatalogProvider } from './context';
import { useProgramCatalogPageProps } from './data/useProgramCatalogPageProps';
import { ProgramCatalogLayout } from './layouts';
import { LoadingPage } from '~/pages/LoadingPage';
import { ErrorPage, ErrorHandler } from '~/pages/ErrorPage';
import { useWindowDocumentTitle } from '~/lib/useWindowDocumentTitle';

export function ProgramCatalogPage() {
  useWindowDocumentTitle('Program Catalog');
  const { initialProps, isLoadingInitialProps, isInitialPropsError, initialPropsError } = useProgramCatalogPageProps();

  if (!isInitialPropsError && isLoadingInitialProps) {
    return <LoadingPage />;
  }
  if (isInitialPropsError) {
    return <ErrorHandler error={initialPropsError} />;
  }
  if (!initialProps) {
    return <ErrorPage customMessage="Failed to fetch page props." />;
  }

  return (
    <ProgramCatalogProvider initialProps={initialProps}>
      <ProgramCatalogLayout />
    </ProgramCatalogProvider>
  );
}
